import { useEffect } from 'react';
import { useIntercom } from 'react-use-intercom';

import { useIsDesktop } from '../../../hooks/useIsDesktop';
import { useScrollDetection } from '../../../hooks/useScrollDetection';

export function LandingPageIntercomButton() {
  const { update } = useIntercom();
  const isDesktop = useIsDesktop();
  const hasScrolled = useScrollDetection(50);

  // Show button if:
  // - On desktop (always)
  // - On mobile/tablet and user has scrolled
  const shouldShowButton = isDesktop || hasScrolled;

  useEffect(() => {
    update({
      hideDefaultLauncher: !shouldShowButton,
    });
  }, [shouldShowButton, update]);

  return null;
}
